export default __webpack_public_path__ + "static/media/planninganalytics.994530c7.svg";